import React, { Component, Fragment } from 'react'
import CustomTable from '../../../../../elements/Table/CustomTable'
import { moneyColumn, sessionItemVal } from '../../../../../modules/Utils'
import { Alert, Badge } from 'antd'
import InfoText from '../../../../../elements/InfoText'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import DateCell from '../../../../../elements/Table/Cells/DateCell'

const CheckboxTable = checkboxHOC(CustomTable)

class TransactionsCompareList extends Component {
  columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ original, value }) => {
        return original._id ? (
          <span>To be Uploaded</span>
        ) : (
          <a>
            <Badge dot style={{ background: '#2db731', marginRight: 10 }}/>
            {value}
          </a>
        )
      },
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateCell,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      style: { textAlign: 'right' },
      sortMethod: (a, b) => (Number.parseFloat(a) < Number.parseFloat(b) ? 1 : -1),
      Cell: ({ value }) => moneyColumn(value),
    },
    {
      Header: 'Type',
      accessor: 'type',
      Cell: ({ value }) => sessionItemVal('transactions_type_dropdown', value),
    },
    {
      Header: 'Transactions Ref',
      accessor: 'remittance.ref',
      width: 250,
    },
    {
      Header: 'notes',
      accessor: 'notes',
    },
  ]

  render () {
    const { list, selectAll, selection, isSelected, toggleSelection, toggleAll } = this.props
    const checkboxProps = {
      selectType: 'checkbox',
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
    }
    return (
      <Fragment>
        <InfoText
          text={
            'This Table data is combined with the ones existed in the system to compare wither this data uploaded before.'
          }
        />
        <InfoText
          text={
            'You can differentiate between current transactions and to be uploaded ones by the Transaction ID and Green Badge in each row.'
          }
        />
        <InfoText text={'You can filter the table by clicking on the filter button.'}/>
        <br/>
        {selection.length > 0 && (
          <Alert message={`Records to be uploaded ${selection.length}`} type="info"/>
        )}
        <CheckboxTable
          columns={this.columns}
          data={list}
          hide={{ refresh: true }}
          indexKey={'_key'}
          isFilterable={true}
          defaultSorted={[
            {
              id: 'date',
              desc: false,
            },
            {
              id: 'amount',
              desc: false,
            },
          ]}
          {...checkboxProps}
        />
      </Fragment>
    )
  }
}

TransactionsCompareList.propTypes = {}
TransactionsCompareList.defaultProps = {}

export default TransactionsCompareList
